/**
 * @file: 提交成功页
 * @author: wence
 */
import React, {PureComponent} from 'react';
import Proptype from 'prop-types';
import './successPage.less';
export default class SuccessPage extends PureComponent {
    static propTypes = {
        match: Proptype.object
    }

    componentDidMount() {
        // 将最小高度去除掉
        setTimeout(() => {
            this.node && this.node.parentNode && (this.node.parentNode.style.minHeight = '');
        }, 0);
    }
    getViewPath = () => {
        const params = this.props.match.params;
        return `/console/#/${params.path}`;
    }

    getReSubmitPath = () => {
        const params = this.props.match.params;
        return `/m/haoma/${params.path}${params.type
            ? `/${params.type}?selectType=${params.selectType || '2'}`
            : ''}`;
    }

    render() {
        return (
            <div ref={node => this.node = node} className="number-success-page">
                <p className="success-title">提交成功</p>
                <p className="success-sub-title">已成功提交，请耐心等待处理</p>
                <div className="success-icon">
                    <img src={require('../../asset/svg/apply-succ.svg')} alt="" />
                </div>
                <div className="success-btn">
                    <a href={this.getViewPath()} className="success-btn-view">
                        查看提交记录
                    </a>
                    <a
                        href={this.getReSubmitPath()}
                        className="success-btn-repost">
                        继续提交
                    </a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/numberOptions/successPage.js